import React from 'react';
import { RouteIcon } from 'lucide-react';
import type { NoteField } from '../../types/disclosure';
interface NotesPanelProps {
  notes: NoteField[];
  showApiNames: boolean;
}
export function NotesPanel({
  notes,
  showApiNames
}: NotesPanelProps) {
  const [primary, ...supporting] = notes;
  return <div className="flex h-full flex-col gap-4" data-id="element-38" data-mp="37xm4btikmxom">
      <article className="flex min-h-[320px] flex-1 flex-col overflow-hidden rounded-md border border-blue-200 bg-blue-50/40" data-id="element-39" data-mp="37wudevzx5o4o">
        <header className="flex items-center gap-2 border-b border-blue-200 bg-blue-100/60 px-4 py-2.5" data-id="element-40" data-mp="2xywqqcxpjze6">
          <RouteIcon className="h-4 w-4 text-blue-700" aria-hidden="true" data-id="element-41" data-mp="2szk0rjbjic7d" />
          <h3 className="text-xs font-bold uppercase tracking-wide text-blue-900 underline decoration-blue-300 decoration-1 underline-offset-4" data-id="element-42" data-mp="2t1n1axabjnqc">
            {primary.label}
          </h3>
          {showApiNames && <span className="font-mono text-[10px] text-blue-600" data-id="element-43" data-mp="r647sfrzcl98">{primary.api}</span>}
        </header>
        <div className="flex-1 px-4 py-4" data-id="element-44" data-mp="37njhvdse7gt2">
          {primary.value ? <p className="whitespace-pre-line text-sm leading-7 text-slate-800" data-id="element-45" data-mp="37m8f9haoof3j">{primary.value}</p> : <p className="text-sm italic text-slate-400" data-id="element-46" data-mp="3ck9xk00acady">No roadmap notes recorded.</p>}
        </div>
      </article>

      <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-47" data-mp="32nx4n4cke0k9">
        {supporting.map(note => <article key={note.id} className="flex min-h-[112px] flex-col rounded-md border border-slate-200 bg-white px-3.5 py-3" data-id="element-48" data-mp="3qeb074ucyhjl">
            <h3 className="text-[11px] font-bold uppercase tracking-wide text-slate-600 underline decoration-slate-300 decoration-1 underline-offset-4" data-id="element-49" data-mp="3vccl7vbcgqxp">
              {note.label}
            </h3>
            {showApiNames && <p className="font-mono text-[10px] text-slate-400" data-id="element-50" data-mp="3lkyd4z5buisy">{note.api}</p>}
            {note.value ? <p className="mt-1.5 whitespace-pre-line text-[13px] leading-6 text-slate-800" data-id="element-51" data-mp="hy7siz38wsv9">{note.value}</p> : <p className="mt-1.5 text-[13px] italic text-slate-400" data-id="element-52" data-mp="ruhol3nay65k">Not provided</p>}
          </article>)}
      </div>
    </div>;
}